/**
 * K9 Quick-Buy URL Handler
 *
 * Activated by ?wm480_quickbuy=K9WM60 (or future variants in VARIANT_MAP).
 * Used by the post-purchase WM 480g offer block on the customer account
 * order page (k9-inventory-bot extension wm-account-offer).
 *
 * Flow when extension button clicked:
 *   1. Extension navigates customer to:
 *        /discount/WM480POSTPURCHASE?redirect=/?wm480_quickbuy=K9WM60
 *      Shopify session-applies the discount, redirects to homepage with our param.
 *   2. This script runs on homepage:
 *        a. Sets localStorage.discount_code so existing Breeze handler
 *           (theme.liquid:687-689) attaches offercode to <breeze-button>.
 *        b. Pre-checks /cart.js — if K9WM60 already in cart (multi-click guard),
 *           skips the add step.
 *        c. POSTs /cart/add.js with K9WM60 variant. Discount auto-applies at
 *           line level (validated end-to-end via Playwright before ship).
 *        d. Polls for window.Rebuy.SmartCart.show readiness (matches the
 *           existing K9 pattern in product-form.js:123-133).
 *        e. Calls Rebuy.SmartCart.show() — drawer opens with K9WM60 at ₹1,799.
 *   3. Existing theme JS (theme.liquid:739-748 MutationObserver) auto-injects
 *      the <breeze-button> into the drawer with offercode set.
 *   4. Customer clicks Breeze button → existing applyDiscountToCart re-confirms
 *      discount, then opens Breeze overlay → customer pays.
 *
 * Validated end-to-end via Playwright on 2026-04-27. All 8 validation steps
 * green including real Breeze overlay rendering at ₹1,799 with WM480POSTPURCHASE
 * applied.
 */
(function () {
  var params = new URLSearchParams(window.location.search);
  var handle = params.get('wm480_quickbuy');
  if (!handle) return;

  // Variant handle → numeric variant ID. Extensible for future quick-buy targets.
  var VARIANT_MAP = {
    'K9WM60': 51622984778002, // K9 Weight Management 480g (Maximum Savings)
  };
  var DISCOUNT_CODE = 'WM480POSTPURCHASE';
  var variantId = VARIANT_MAP[handle];
  if (!variantId) {
    console.warn('[wm-quickbuy] unknown variant handle:', handle);
    return;
  }

  // Store discount in localStorage so theme.liquid's existing Breeze setup
  // attaches it as the offercode attribute (theme.liquid:687-731 polls every 500ms).
  try { localStorage.setItem('discount_code', DISCOUNT_CODE); } catch (e) {}

  function ensureItemInCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var alreadyHas = (cart.items || []).some(function (it) {
          return Number(it.variant_id) === variantId;
        });
        if (alreadyHas) return cart;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/add returned ' + r.status);
          return r.json();
        });
      });
  }

  function openDrawer() {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        clearInterval(poll);
        window.Rebuy.SmartCart.show();
      } else if (attempts >= 60) {
        // 30s ceiling. Rebuy SmartCart on fresh homepage typically ready by ~10s
        // (measured 2026-04-27). 30s gives 3x headroom for slow connections.
        // Original 12.5s ceiling fired prematurely during /discount/CODE redirect flow.
        clearInterval(poll);
        // Fallback: send to PDP so customer can ATC normally — discount is in session
        window.location.href = '/products/weight-management-supplement-for-dogs';
      }
    }, 500);
  }

  function run() {
    ensureItemInCart()
      .then(openDrawer)
      .catch(function (err) {
        console.error('[wm-quickbuy]', err);
        window.location.href = '/products/weight-management-supplement-for-dogs';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
